export const STEP_CREATE_NEW = 1;
export const STEP_SELECT_TEMPLATE = 2;

export const STEP_FINAL = 3;
